import { z } from 'zod'

export const WeeklyPeriodValueSchema = z
  .string()
  .regex(/^W\d{4}\|(0[1-9]|[1-4][0-9]|5[0-2])$/, 'Invalid weekly period format')
export type WeeklyPeriodValue = z.infer<typeof WeeklyPeriodValueSchema>

export const QuarterlyPeriodValueSchema = z.string().regex(/^Q\d{4}\|[1-4]$/, 'Invalid quarterly period format')
export type QuarterlyPeriodValue = z.infer<typeof QuarterlyPeriodValueSchema>

export const PlanPeriodValueSchema = z.union([WeeklyPeriodValueSchema, QuarterlyPeriodValueSchema])
export type PlanPeriodValue = z.infer<typeof PlanPeriodValueSchema>

export const WeeklyPlanSchema = z.object({
  periodType: z.literal('week'),
  period: WeeklyPeriodValueSchema,
})
export type WeeklyPlan = z.infer<typeof WeeklyPlanSchema>

export const QuarterlyPlanSchema = z.object({
  periodType: z.literal('quarter'),
  period: QuarterlyPeriodValueSchema,
})
export type QuarterlyPlan = z.infer<typeof QuarterlyPlanSchema>

export const PlanPeriodSchema = z.union([WeeklyPlanSchema, QuarterlyPlanSchema])
export type PlanPeriod = z.infer<typeof PlanPeriodSchema>

export const PlanPeriodTypeSchema = z.enum(['week', 'quarter'])
export type PlanPeriodType = z.infer<typeof PlanPeriodTypeSchema>
